export default {
	namespaced: true,
	state: {
		type: 'list',
	},
	getters: {

	},
	mutations: {
		set_type(state, params) {
			state.type = params;
		},
	},
	actions: {

	},
};
